/**
 * Returns a function that prefixes a path with the locale segment.
 * Similar to Nuxt-i18n `useLocalePath()` composable but since we
 * disabled prefix in i18n strategy, we need our own function.
 * @see https://i18n.nuxtjs.org/docs/composables/use-locale-path
 *
 * @example Usage:
 * const localizedPath = useLocalizedPath();
 * localizedPath('/shop'); // '/de-de/shop'
 * localizedPath('https://example.test/course/1'); // 'https://example.test/course/1'
 * localizedPath('www.example.test'); // 'https://www.example.test'
 * @returns A function that prefixes a path with the locale segment
 */
export function useLocalizedPath() {
    const { urlSegment } = useLanguage();

    return (path: string) => prefixLocalePath(path, urlSegment.value);
}
